import React, { useCallback, useState } from 'react'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import SettingsIcon from '@mui/icons-material/AutoAwesomeTwoTone'

import { HeaderModal } from './HeaderModal'
import { useAppSelector } from 'redux/Hook'
import { useAnalyticsToggles } from 'containers/TextAnalysis/Header/Hooks/UseSentimentAction'

export const HeaderAction = () => {
  const [open, setOpen] = useState(false)
  const {
    appConfig: {
      platformSentiment,
      platformThemes_keyphrases,
      sentimentToggle,
      ownerConfigId,
      themes_keyphrasesToggle,
    },
  } = useAppSelector((state) => state.textAnalysis.main)

  const handleSettingsOpen = useCallback(() => {
    setOpen(true)
  }, [])

  const handleClose = useCallback(() => {
    setOpen(false)
  }, [])

  const { handleSave } = useAnalyticsToggles({
    ownerConfigId,
    handleClose,
  })

  return (
    <Box
      display="flex"
      justifyContent="flex-end"
      alignItems="center"
      data-testid="ta-header-action"
    >
      <Box display="flex" justifyContent="flex-end">
        <Button
          variant="outlined"
          startIcon={<SettingsIcon />}
          onClick={handleSettingsOpen}
          aria-label="Smart Analysis settings"
          sx={{ color: 'primary.dark' }}
        >
          AI Settings
        </Button>
      </Box>
      {open && (
        <HeaderModal
          open={open}
          sentimentStatus={sentimentToggle}
          thematicStatus={themes_keyphrasesToggle}
          onClose={handleClose}
          onSave={handleSave}
          sentimentAnalysis={platformSentiment}
          thematicAnalysis={platformThemes_keyphrases}
        />
      )}
    </Box>
  )
}
